import Nav from '../Components/nav';

type LazyModule = {
    default: {
        init: () => void;
    };
};

type ModuleEntry = [
    selector: string,
    loader: () => Promise<LazyModule>
];

const modules: ModuleEntry[] = [
    [".js-scroll-top", () => import('../Components/scrollTop')],
    [".js-vid-lazy", () => import('../Components/lazyLoadVideos')],
    [".js-search-form", () => import('../Components/siteSearch')],
    [".js-imgv", () => import('../Components/imageViewer')],
    [".js-accordion", () => import('../Components/accordion')],
    [".js-accordian", () => import('../Components/accordian')],
    [".js-tabs", () => import('../Components/tabs')],
    [".js-slider", () => import('../Components/slider')],
    [".js-focus-inp", () => import('../Components/focusInp')],
    [".js-scroll-to", () => import('../Components/scrollTo')],
    [".js-modal", () => import('../Components/modal')],
    [".js-carousel", () => import('../Components/carousel')],
    [".js-promo-bar", () => import('../Components/promoBar')],
    [".js-hs-form", () => import('../Components/hubspotForm')],
    [".js-img-rsp-mw", () => import('../Components/maxWidthImg')],
    [".js-form", () => import('../Components/forms')],
    [".js-expand", () => import('../Components/expand')],
    [".js-vbsmv", () => import('../Components/arModelViewer')],
    [".js-pgl", () => import('../Components/pageList')],
    [".js-btn-pnl-rvl", () => import('../Components/pnlrvl')],
    [".js-prd-flt", () => import('../Components/productFilter')],
    [".js-btn-fav", () => import('../Components/favourites')],
    [".js-unit-toggle", () => import('../Components/unit-toggle')],
    [".js-conv", () => import('../Components/conversion')],
    [".js-plf-fnd", () => import('../Components/platform-finder-app')],
    [".js-prod-card-intel", () => import('../Components/prodCardIntel')],
    [".js-btn-busy", () => import('../Components/busybtn')],
    [".js-reporting", () => import('../Components/reporting')],
    [".js-a-link", () => import('../Components/aLink')],
];

const loadIfPresent = ([selector, loader]: ModuleEntry) => {
    if (!document.querySelector(selector)) return;

    loader()
        .then(m => m.default.init())
        .catch(err =>
            console.error(`Lazy module failed for ${selector}`, err)
        );
};

document.addEventListener('DOMContentLoaded', () => {
    modules.forEach(loadIfPresent);

    if (document.getElementById('myAccApp')) {
        import('../MyAccount/_init');
    }

    Nav.init();
});